module.exports = __webpack_public_path__ + "img/t_bimg.219d507d.png";